import { pumaAPI } from "./api"

export const getShortcuts = (
    workspaceId: number | null,
    filter?: string,
): Promise<Api.PumaParsedPaginatedResponse<Models.Shortcut>> =>
    pumaAPI
        .getJSON("shortcuts", { filter, workspaceId })
        .then((shortcuts: Api.PumaPaginatedResponse<Api.ShortcutDTO>) => ({
            paging: {
                pageSize: shortcuts.Paging.PageSize,
                totalRecordCount: shortcuts.Paging.TotalRecordCount,
            },
            data: shortcuts.Data.$values.map((shortcut: Api.ShortcutDTO) => ({
                id: shortcut.Id,
                url: shortcut.Url,
                title: shortcut.Title,
                workspaceId: shortcut.WorkspaceId,
                workspaceLabel: shortcut.WorkspaceScreenLabel,
                linkData:
                    !!shortcut.Url || !shortcut.Data
                        ? undefined
                        : {
                              itemId: shortcut.Data.ItemId,
                              parentId: shortcut.Data.ParentId,
                              conceptId: shortcut.Data.ListId,
                              collectionId: shortcut.Data.SelectionId,
                              workspaceId: shortcut.Data.WorkspaceId,
                              attachmentId: shortcut.Data.AttachmentId,
                              scriptId: shortcut.Data.ScriptId,
                              listScriptId: shortcut.Data.ListScriptId,
                              hasParameters: shortcut.Data.HasParameters,
                          },
            })),
        }))
